import react from 'react';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Web from './pages/Web';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';


function App() {
  
  return (
      <Router>
      <div className="">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/web" element={<Web />} />
        </Routes>
      </div>
    </Router>

  );
}

export default App;







